import { Card, CardContent } from "@babackapp/ui/components/card";
import TeamMembersList from "./team-members-list";

export default function TeamMembersCard() {
  return (
    <Card>
      <CardContent className="pt-8">
        <TeamMembersList />
      </CardContent>
    </Card>
  );
}
